import {
  CREATE_ROLES_SUCCESS,
  DELETE_ROLES_SUCCESS,
  FETCH_ROLES_SUCCESS,
  GET_ROLES_SUCCESS,
  ROLES_FAILURE,
  ROLES_REQUEST,
  UPDATE_ROLES_SUCCESS,
} from "../action/types";

const initialState = {
  roles: [],
  total: 0,
  currentRole: null,
  loading: false,
  error: null,
};

const roleReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ROLES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: payload?.data ?? (Array.isArray(payload) ? payload : []),
        total: payload?.total ?? (Array.isArray(payload) ? payload.length : 0),
      };

    case GET_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        currentRole: payload,
        roles: state.roles.map((item) =>
          item.id === payload?.id ? payload : item,
        ),
      };

    case CREATE_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: [payload, ...state.roles],
        total: state.total + 1,
      };

    case UPDATE_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: state.roles.map((item) =>
          item.id === payload?.id ? payload : item,
        ),
      };

    case DELETE_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: state.roles.filter((item) => item.id !== payload),
        total: state.total - 1,
      };

    case ROLES_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default roleReducer;
